// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('FriendInfoVO')
export class FriendInfoVO {
  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('username', 'String')
  public username: string = undefined;

  public clone(): FriendInfoVO {
    const clonedData: FriendInfoVO = new FriendInfoVO();
    clonedData.id = this.id;
    clonedData.username = this.username;
    return clonedData;
  }
}
